
import React  from "react";
import { Link } from "react-router-dom";
import { Container , Row , Col } from "reactstrap";
import './Stepsection.css';


function  Stepsection ()  {

    const STEP__DATA =  [
        {
            title: "Setup Your Wallet " , 
            desc: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem" ,
            icon: "ri-wallet-line",
        },
        {
            title: "Create Your Collection " , 
            desc: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem" ,
            icon: "ri-layout-masonry-line",
        },
        {
            title: "Add Your  NFTS " , 
            desc: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem" ,
            icon: "ri-file-image-line",
        },
        {
            title: "List Them For Sale " , 
            desc: "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem" ,
            icon: "ri-list-check",
        },

    ];


    return(
        <section>
            <Container>
                <Row>
                    <Col lg="12"  className="mb-4">
                        <h3  className="step__title"> Create and sell Your NFTS </h3>
                    </Col>
                    {
                        STEP__DATA.map((item , index) => {
                            return(
                                <Col  className="mb-4" key={index} lg="3"  md="4"  sm="6">
                                    <div  className="single__step__item">
                                        <span>  <i class={item.icon}></i>  </span>
            
                                        <div  className="step__item__content">
                                            <h5> <Link  to='/wallet'> {item.title}  </Link>  </h5>
                                            <p> 
                                                {item.desc}
                                            </p>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })
                    }

            

                </Row>
            </Container>

        </section>
    );
}

export  default  Stepsection;

